import React from 'react';
import './footer.styles.scss';

const Footer = () => {
  return (
    <div className="footer">
      <h3>Developed By - <a href="https://github.com/psaksena85">Pulkit Saxena</a></h3>
      <p><sub>Data - <a href="https://disease.sh/">Novel COVID API</a></sub></p>
    </div>
  );
}

export default Footer;